import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetPR_TransferItemInformationListByApplicationGuid =
  createAsyncThunk(
    "TransferItemInformation/GetPR_TransferItemInformationListByApplicationGuid",
    async (aI_ApplicationInformationId, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/TransferItemInformation/GetPR_TransferItemInformationListByApplicationGuid",
          {
            aI_ApplicationInformationId: aI_ApplicationInformationId,
          }
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const GetAllPR_TransferItemInformationFormManager = createAsyncThunk(
  "TransferItemInformation/GetAllPR_TransferItemInformationFormManager",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferItemInformation/GetAllPR_TransferItemInformationFormManager",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetOnePR_TransferItemInformationByID = createAsyncThunk(
  "TransferItemInformation/GetOnePR_TransferItemInformationByID",
  async (pR_TransferItemInformationGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferItemInformation/GetOnePR_TransferItemInformationByID",
        {
          pR_TransferItemInformationGuid: pR_TransferItemInformationGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddPR_TransferItemInformation = createAsyncThunk(
  "TransferItemInformation/AddPR_TransferItemInformation",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferItemInformation/AddPR_TransferItemInformation",

        {
          stageFromTransfer: Parameter.stageFromTransfer,
          stageToTransfer: Parameter.stageToTransfer,
          transferValue: Parameter.transferValue,
          pR_ReportsStagesGuid: Parameter.pR_ReportsStagesGuid,
          pR_TransferInformationStatusGUID:
            Parameter.pR_TransferInformationStatusGUID,
          pR_ItemTypeFrom: Parameter.pR_ItemTypeFrom,
          pR_ItemTypeTo: Parameter.pR_ItemTypeTo,
          itemFromTransfer: Parameter.itemFromTransfer,
          itemToTransfer: Parameter.itemToTransfer,
          aI_ApplicationInformationId: Parameter.aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdatePR_TransferItemInformation = createAsyncThunk(
  "TransferItemInformation/UpdatePR_TransferItemInformation",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferItemInformation/UpdatePR_TransferItemInformation",
        {
          pR_TransferItemInformationGuid:
            Parameter.pR_TransferItemInformationGuid,
          stageFromTransfer: Parameter.stageFromTransfer,
          stageToTransfer: Parameter.stageToTransfer,
          transferValue: Parameter.transferValue,
          pR_ReportsStagesGuid: Parameter.pR_ReportsStagesGuid,
          pR_TransferInformationStatusGUID:
            Parameter.pR_TransferInformationStatusGUID,
          pR_ItemTypeFrom: Parameter.pR_ItemTypeFrom,
          pR_ItemTypeTo: Parameter.pR_ItemTypeTo,
          itemFromTransfer: Parameter.itemFromTransfer,
          itemToTransfer: Parameter.itemToTransfer,
          aI_ApplicationInformationId: Parameter.aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeletePR_TransferItemInformation = createAsyncThunk(
  "TransferItemInformation/DeletePR_TransferItemInformation",
  async (pR_TransferItemInformationGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferItemInformation/DeletePR_TransferItemInformation",
        {
          pR_TransferItemInformationGuid: pR_TransferItemInformationGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetReportStatusByApplicationGuid = createAsyncThunk(
  "TransferItemInformation/GetReportStatusByApplicationGuid",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferItemInformation/GetReportStatusByApplicationGuid",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ChangeTransferStatusById = createAsyncThunk(
  "TransferItemInformation/ChangeTransferStatusById",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferItemInformation/ChangeTransferStatusById",
        {
          pR_TransferItemInformationGUID: model.pR_TransferItemInformationGUID,
          PR_TransferInformationStatusGUID:
            model.PR_TransferInformationStatusGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TransferItemInformation = createSlice({
  name: "TransferItemInformation",
  initialState: {
    // ------------------------- get list  -------------------------------
    TransferItemInformationList: [],
    loadingTransferItemInformationList: false,
    errorTransferItemInformationList: null,
    // ------------------------- manager -------------------------------
    TransferListManager: [],
    loadingTransferListManager: false,
    errorTransferListManager: null,
    // ------------------------- get one -------------------------------
    TransferOne: {},
    loadingTransferOne: false,
    errorTransferOne: null,
    // ------------------------ add --------------------------------
    AddTransfer: [],
    loadingAddTransfer: false,
    errorAddTransfer: null,
    // ------------------------- update-------------------------------
    UpdateTransfer: [],
    loadingUpdateTransfer: false,
    errorUpdateTransfer: null,
    // ------------------------- delete -------------------------------
    DeleteTransfer: [],
    loadingDeleteTransfer: false,
    errorDeleteTransfer: null,

    // ------------------------- GetReportStatusByApplicationGuid -------------------------------
    ReportStatusByApplicationGuid: {},
    loadingReportStatusByApplicationGuid: false,
    errorReportStatusByApplicationGuid: null,

    // ------------------------- ChangeTransferStatusById -------------------------------
    ChangeTransferStatus: {},
    loadingChangeTransferStatus: false,
    errorChangeTransferStatus: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    //----------------------------------- get list ---------------------------------------------
    builder
      .addCase(
        GetPR_TransferItemInformationListByApplicationGuid.pending,
        (state, action) => {
          state.loadingTransferItemInformationList = true;
          state.TransferItemInformationList = action.payload;
          state.errorTransferItemInformationList = null;
        }
      )
      .addCase(
        GetPR_TransferItemInformationListByApplicationGuid.fulfilled,
        (state, action) => {
          state.loadingTransferItemInformationList = false;
          state.TransferItemInformationList = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetPR_TransferItemInformationListByApplicationGuid.rejected,
        (state, action) => {
          state.loadingTransferItemInformationList = false;
          state.errorTransferItemInformationList = action.payload;
        }
      );
    // -------------------------- list manager ------------------------------

    builder
      .addCase(
        GetAllPR_TransferItemInformationFormManager.pending,
        (state, action) => {
          state.loadingTransferListManager = true;
          state.TransferListManager = action.payload;
          state.errorTransferListManager = null;
        }
      )
      .addCase(
        GetAllPR_TransferItemInformationFormManager.fulfilled,
        (state, action) => {
          state.loadingTransferListManager = false;
          state.TransferListManager = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetAllPR_TransferItemInformationFormManager.rejected,
        (state, action) => {
          state.loadingTransferListManager = false;
          state.errorTransferListManager = action.payload;
        }
      );
    // ------------------------- get one -------------------------------
    builder
      .addCase(
        GetOnePR_TransferItemInformationByID.pending,
        (state, action) => {
          state.loadingTransferOne = true;
          state.TransferOne = action.payload;
          state.errorTransferOne = null;
        }
      )
      .addCase(
        GetOnePR_TransferItemInformationByID.fulfilled,
        (state, action) => {
          state.loadingTransferOne = false;
          state.TransferOne = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOnePR_TransferItemInformationByID.rejected,
        (state, action) => {
          state.loadingTransferOne = false;
          state.errorTransferOne = action.payload;
        }
      );
    // --------------------------- Add -----------------------------
    builder
      .addCase(AddPR_TransferItemInformation.pending, (state, action) => {
        state.loadingAddTransfer = true;
        state.AddTransfer = action.payload;
        state.errorAddTransfer = null;
      })
      .addCase(AddPR_TransferItemInformation.fulfilled, (state, action) => {
        state.loadingAddTransfer = false;
        state.AddTransfer = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddPR_TransferItemInformation.rejected, (state, action) => {
        state.loadingAddTransfer = false;
        state.errorAddTransfer = action.payload;
      });

    // ------------------------ update --------------------------------

    builder
      .addCase(UpdatePR_TransferItemInformation.pending, (state, action) => {
        state.loadingUpdateTransfer = true;
        state.UpdateTransfer = action.payload;
        state.errorUpdateTransfer = null;
      })
      .addCase(UpdatePR_TransferItemInformation.fulfilled, (state, action) => {
        state.loadingUpdateTransfer = false;
        state.UpdateTransfer = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdatePR_TransferItemInformation.rejected, (state, action) => {
        state.loadingUpdateTransfer = false;
        state.errorUpdateTransfer = action.payload;
      });

    // ------------------------ Delete --------------------------------

    builder
      .addCase(DeletePR_TransferItemInformation.pending, (state, action) => {
        state.loadingDeleteTransfer = true;
        state.DeleteTransfer = action.payload;
        state.errorDeleteTransfer = null;
      })
      .addCase(DeletePR_TransferItemInformation.fulfilled, (state, action) => {
        state.loadingDeleteTransfer = false;
        state.DeleteTransfer = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeletePR_TransferItemInformation.rejected, (state, action) => {
        state.loadingDeleteTransfer = false;
        state.errorDeleteTransfer = action.payload;
      });

    // ------------------------ GetReportStatusByApplicationGuid --------------------------------

    builder
      .addCase(GetReportStatusByApplicationGuid.pending, (state, action) => {
        state.loadingReportStatusByApplicationGuid = true;
        state.ReportStatusByApplicationGuid = action.payload;
        state.errorReportStatusByApplicationGuid = null;
      })
      .addCase(GetReportStatusByApplicationGuid.fulfilled, (state, action) => {
        state.loadingReportStatusByApplicationGuid = false;
        state.ReportStatusByApplicationGuid = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetReportStatusByApplicationGuid.rejected, (state, action) => {
        state.loadingReportStatusByApplicationGuid = false;
        state.errorReportStatusByApplicationGuid = action.payload;
      });

       // ------------------------ ChangeTransferStatus --------------------------------

    builder
    .addCase(ChangeTransferStatusById.pending, (state, action) => {
      state.loadingChangeTransferStatus = true;
      state.ChangeTransferStatus = action.payload;
      state.errorChangeTransferStatus = null;
    })
    .addCase(ChangeTransferStatusById.fulfilled, (state, action) => {
      state.loadingChangeTransferStatus = false;
      state.ChangeTransferStatus = action.payload; // Assuming payload has the desired data
    })
    .addCase(ChangeTransferStatusById.rejected, (state, action) => {
      state.loadingChangeTransferStatus = false;
      state.errorChangeTransferStatus = action.payload;
    });
  },
});

export default TransferItemInformation.reducer;
